import { ROLES_LIST } from "../../features/roles/roles.config";
import Iconify from "../iconify/Iconify";
import EDojangNavIcon from "../iconify/EDojangNavIcon";
import { FEATURE_KEYS } from "../../utils/planFeatures";

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: "Startseite",
    path: "/dashboard/home",
    icon: <Iconify icon={"ion:home"} width={24} height={24} />,
    role: ROLES_LIST.Mitglied,
    memberOnly: true,
  },
  {
    title: "Meine Daten",
    path: "/dashboard/meine-daten",
    icon: <Iconify icon={"mdi:account-edit-outline"} width={24} height={24} />,
    role: ROLES_LIST.Mitglied,
    featureKey: FEATURE_KEYS.MEMBER_PORTAL,
    memberOnly: true,
  },
  {
    title: "Standorte",
    path: "/dashboard/standorte",
    icon: <Iconify icon={"fa-solid:torii-gate"} width={24} height={24} />,
    role: ROLES_LIST.Mitglied,
    featureKey: FEATURE_KEYS.MEMBER_PORTAL,
    memberOnly: true,
  },
  {
    title: "Home",
    path: "/dashboard/app",
    icon: <Iconify icon={"ion:home"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.HOME,
  },
  {
    title: "Neuigkeiten",
    path: "/dashboard/news",
    icon: (
      <Iconify icon={"mdi:newspaper-variant-outline"} width={24} height={24} />
    ),
    role: [ROLES_LIST.User, ROLES_LIST.Mitglied],
    featureKey: FEATURE_KEYS.NEWS,
  },
  {
    title: "E-Dojang",
    path: "/dashboard/e-dojang",
    icon: <EDojangNavIcon />,
    role: [
      ROLES_LIST.User,
      ROLES_LIST.Editor,
      ROLES_LIST.Admin,
      ROLES_LIST.SuperAdmin,
      ROLES_LIST.Mitglied,
    ],
    featureKey: FEATURE_KEYS.E_DOJANG,
  },
  {
    title: "Veranstaltungen",
    path: "/dashboard/veranstaltungen",
    icon: <Iconify icon={"fa-solid:calendar-check"} width={24} height={24} />,
    role: ROLES_LIST.Mitglied,
    featureKey: FEATURE_KEYS.EVENTS,
    memberOnly: true,
  },
  {
    title: "Prüfungsgebühren",
    path: "/dashboard/testing-fees",
    icon: <Iconify icon={"mdi:cash-check"} width={24} height={24} />,
    role: ROLES_LIST.Mitglied,
    featureKey: FEATURE_KEYS.MEMBER_PORTAL,
    memberOnly: true,
  },
  {
    title: "Benutzer",
    path: "/dashboard/user",
    icon: <Iconify icon={"fa-solid:user"} width={24} height={24} />,
    role: ROLES_LIST.Admin,
    featureKey: FEATURE_KEYS.USERS,
  },
  {
    title: "Aufgaben",
    path: "/dashboard/tasks",
    icon: (
      <Iconify icon={"majesticons:analytics-plus"} width={24} height={24} />
    ),
    role: [ROLES_LIST.User, ROLES_LIST.Mitglied],
    featureKey: FEATURE_KEYS.TASKS,
  },
  {
    title: "Standorte",
    path: "/dashboard/sites",
    icon: <Iconify icon={"fa-solid:torii-gate"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.SITES,
  },
  {
    title: "Mitglieder",
    path: "/dashboard/members",
    icon: <Iconify icon={"fa-solid:users"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.MEMBERS,
  },
  {
    title: "Vertragsdaten",
    path: "/dashboard/contracts",
    icon: <Iconify icon={"fa-solid:address-book"} width={24} height={24} />,
    role: [ROLES_LIST.Admin, ROLES_LIST.SuperAdmin],
    featureKey: FEATURE_KEYS.CONTRACTS,
  },
  {
    title: "Banking",
    path: "/dashboard/banking",
    icon: (
      <Iconify icon={"fa-solid:file-invoice-dollar"} width={24} height={24} />
    ),
    role: ROLES_LIST.Admin,
  },
  {
    title: "Training",
    path: "/dashboard/trainer",
    icon: <Iconify icon={"fa-solid:street-view"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.TRAINING,
  },
  {
    title: "Prüfungen",
    path: "/dashboard/testings",
    icon: <Iconify icon={"fa-solid:award"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.TESTINGS,
  },
  {
    title: "Turniere",
    path: "/dashboard/tournaments",
    icon: <Iconify icon={"fa-solid:trophy"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.TOURNAMENTS,
  },
  {
    title: "Veranstaltungen",
    path: "/dashboard/events",
    icon: <Iconify icon={"fa-solid:star"} width={24} height={24} />,
    role: ROLES_LIST.User,
    featureKey: FEATURE_KEYS.EVENTS,
  },
  {
    title: "Shop",
    path: "/dashboard/shop",
    icon: <Iconify icon={"game-icons:shop"} width={24} height={24} />,
    role: [ROLES_LIST.User, ROLES_LIST.Mitglied],
    featureKey: FEATURE_KEYS.SHOP,
  },
  {
    title: "Support",
    path: "/dashboard/support",
    icon: <Iconify icon={"mdi:lifebuoy"} width={24} height={24} />,
    role: ROLES_LIST.User,
  },
  {
    title: "Mandanten",
    path: "/dashboard/tenants",
    icon: <Iconify icon={"mdi:office-building-cog"} width={24} height={24} />,
    role: ROLES_LIST.SuperAdmin,
  },
  {
    title: "Einstellungen",
    path: "/dashboard/settings",
    icon: <Iconify icon={"mdi:cog"} width={24} height={24} />,
    role: ROLES_LIST.Admin,
    featureKey: FEATURE_KEYS.SYSTEM,
  },
  {
    title: "Befragung",
    path: "/dashboard/survey",
    icon: <Iconify icon={"wpf:survey"} width={24} height={24} />,
    role: [ROLES_LIST.User, ROLES_LIST.Mitglied],
    featureKey: FEATURE_KEYS.SURVEY,
    show: true,
    info: "Mitarbeiter- und Patientenbefragungen erstellen, bearbeiten und auswerten.",
  },
];

export default navConfig;
